<template>
    <!-- SCEDULE TOUR MODAL -->
<div class="modal fade partnerModal" id="sceduleTourModal" tabindex="-1" aria-labelledby="ssceduleTourModalLabel" aria-hidden="true" ref="sceduleTourModal">
	<div class="modal-dialog modal-lg modal-dialog-scrollable opacity-animate3">
		<div class="modal-content">
			<div class="modal-header modalHeader">
				<button type="button" class="custom-close" data-bs-dismiss="modal" v-on:click="modalClose()" aria-label="Close"><i class="ph-x-bold"></i></button>
			</div>
			<div class="modal-body">
				<div class="container-fluid">
					<div class="row">
						<div class="col-sm-12">
							<!-- start schedulePopUp -->
							<div class="plan-future-container" v-if="!isPartner">
								<h5 class="hf_heading05">Schedule a Tour</h5>
								<div class="container-fluid p-0">
									<form action="validatePartnerData" method="post" id="validatePartnerData">
										<div class="row">
											<div class="col-sm-6">
												<div class="form-group hf_input-container">
													<label for="name">Name <span class="hf_primary">*</span></label>
													<input type="text" class="form-control hf_customInput" v-model="fullname" maxlength="100" placeholder="Enter your name">
													<p class="errorMessage" v-if="errors['fullname'] && errors['fullname'] !== ''">
													<span class="errorCircle"><span class="errorSymbol">&#33;</span></span>
													{{ errors["fullname"] }}
													</p> 
												</div>
											</div>
											<div class="col-sm-6">
												<div class="form-group hf_input-container">
													<label for="name">No of people <span class="hf_primary">*</span></label>
													<input type="number" class="form-control hf_customInput" v-model="nopepole" min="0" maxlength="5" @input="pepoleLimit()" placeholder="Enter no of people">
	                        						<p class="errorMessage" v-if="errors['nopepole'] && errors['nopepole'] !== ''">
														<span class="errorCircle"><span class="errorSymbol">&#33;</span></span>
														{{ errors["nopepole"] }}
													</p>
	                      						</div>
											</div>
										</div>
										<div class="row">
											<div class="col-sm-6">
												<div class="form-group hf_input-container">
													<label for="name">Date <span class="hf_primary">*</span></label>
													<input type="date" class="form-control hf_customInput" v-model="date" :min="today" :max="maxDate" @blur="validateDate">
													<p class="errorMessage" v-if="errors['date'] && errors['date'] !== ''">
													<span class="errorCircle"><span class="errorSymbol">&#33;</span></span>
													{{ errors["date"] }}
													</p> 
												</div>
											</div>
											<div class="col-sm-6">
												<div class="form-group hf_input-container">
													<label for="name">Time <span class="hf_primary">*</span></label>
													<input type="time" class="form-control hf_customInput" v-model="time">
													<p class="errorMessage" v-if="errors['time'] && errors['time'] !== ''">
													<span class="errorCircle"><span class="errorSymbol">&#33;</span></span>
													{{ errors["time"] }}
													</p> 
												</div>
											</div>
										</div>
										<div class="row">
											<div class="col-sm-6">
												<div class="form-group hf_input-container abc">
													<label for="number">Contact No. <span class="hf_primary">*</span></label>
													<div class="country-code-container">
														<span class="plus-code">+</span>
														<input type="number" class="form-control hf_customInput conCode" v-model="country_code" :maxlength = "maxCountryCodeLength" >
														<input type="number" class="form-control hf_customInput telNo" v-model="mobile_number" @keypress="isMobileNumber($event)" oninput="javascript: if (this.value.length >this.maxLength) this.value = this.value.slice(0, this.maxLength);" :maxLength = "maxMobileLength" placeholder="Enter your mobile number">
													</div>
													<p class="errorMessage" v-if="errors['mobile_number'] && errors['mobile_number'] !== ''">
														<span class="errorCircle"><span class="errorSymbol">&#33;</span></span>
														{{ errors["mobile_number"] }}
													</p>
												</div>
											</div>
											<div class="col-sm-6">
												<div class="form-group hf_input-container">
													<label for="email">Email <span class="hf_primary">*</span></label>
													<input type="email" class="form-control hf_customInput" v-model="email_address" maxlength="100" placeholder="Enter your email">
													<p class="errorMessage" v-if="errors['email_address'] && errors['email_address'] !== ''">
													<span class="errorCircle"><span class="errorSymbol">&#33;</span></span>
													{{ errors["email_address"] }}
													</p>
												</div>
											</div>
										</div>
										<div class="row">
                      <div class="col-sm-12">
                          <div class="form-group hf_input-container cafe-checkbox">
                              <div class="form-check">
                                  <input class="form-check-input" type="checkbox" value="" id="flexCheckDefault" v-model="isChecked">
                                  <label class="form-check-label" for="flexCheckDefault">
                                      I agree to <span><a href="/terms-conditions">terms and conditions</a> For institutional bookings, write to <span><a href="#">moses.gomes@myfinad.com</a> email id.</span></span>
                                  </label>
                              </div>
                          </div>
	                      </div>
	                  </div>
										<div class="row">
											<div class="col-sm-12">
												<div class="form-group modalCaptcha-div">
													<VueRecaptcha 
											      sitekey="6Ldr460jAAAAAO6wyw1mVTSg_2T2Zp9WTkO9SL_9" 
											      ref="recaptchaModal"
											      size="invisible"
											      :load-recaptcha-script="true" 
											      @verify="recaptchaVerifiedModal" 
											      @expired="resetCaptchaModal">
											    </VueRecaptcha>
											  </div>
											</div>
										</div>
										<!-- button container -->
										<div class="row">
											<div class="col-sm-12">
												<div class="error-div">
												<p v-show="showPartnerError" class="errorMessage inflation-text hf_bodytext02">
													<span class="errorCircle"><span class="errorSymbol">&#33;</span></span>
													{{ showPartnerErrorText }}
												</p>
												</div>
												<div class="form-group hf_input-container">
													<div class="button-container">
														<button :disabled="isFormSubmitting" href="javascript:void(0)" type="button" class="btn-primaryNoIcon lg-primarynoIcon btnScheduleSession" v-on:click="executeCaptcha()">Submit</button>
													</div>
												</div>
											</div>
										</div>
									</form>
								</div>
							</div>
							<!-- end schedulePopUp -->
							<!-- start thank you note container -->
							<div class="thankYou-container" v-if="isPartner">
								<div class="thankYou-body">
									<div class="hoverEffects">
										<img src="https://www.happynessfactory.in/assets/img/HF-Logo-V2.jpg" width="300" height="80" />
									</div>
									<h3 class="hf_bodytext01">Thank you for providing your details. We will get back to you soon!</h3>
									<br/>
									<!-- <p class="hf_heading06">Happyness Factory empowers its MFD partners with an end-to-end<br> integrated technology platform to run their business efficiently, provide<br> them with robust processes and help them with compliance frameworks<br> to ensure faster and better growth.</p> -->
								</div>
								<div class="button-container">
									<a href="javascript:void(0)" type="button" class="btn-primaryNoIcon md-primarynoIcon" v-on:click="modalClose()" data-bs-dismiss="modal" aria-label="Close">Got it</a>
								</div>
							</div>
							<!-- end start thank you note container -->
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
<!-- END SCEDULE TOUR MODAL -->
  </template>
  <script>
  import { VueRecaptcha } from 'vue-recaptcha';
  import { watch } from '@vue/runtime-core';
  export default {
  	components: {
	    VueRecaptcha
	  },
    data() {
		const today = new Date();
		const nextYear = new Date(today);
    	nextYear.setFullYear(today.getFullYear() + 1);
      return {
        fullname: "",
        email_address: "",
        country_code: "91",
        mobile_number: "",
        errors: [],
        nopepole:"",
        date:"",
        time:"",
        isFormSubmitting: true,
				isPartner: false,
        maxCountryCodeLength: 3,
        maxMobileLength: 10,
        recaptchaToken:'',
				showPartnerErrorText:'',
				showPartnerError: false,
				today: today.toISOString().split('T')[0], // Format YYYY-MM-DD
				maxDate: nextYear.toISOString().split('T')[0], // Format YYYY-MM-DD
				isChecked: false
      };
    },
    watch: {
      fullname(userName) {
        this.fullname = userName;
        this.errors["fullname"] = '';
        if( !this.validateCharacters(this.fullname) ) // Check is valid entered name
          this.errors["fullname"] = "Please enter valid Name.";
      },
      email_address(emailAddress) {
        this.email_address = emailAddress;
        let isValidEmail = this.validateEmail(emailAddress);
        this.errors["email_address"] = '';
        if (!isValidEmail) // Check is valid entered email
          this.errors["email_address"] = "Please enter valid Email Address.";
      },
      country_code(countryCode) {
        this.country_code = $.trim(countryCode);
        if (countryCode.toString().length > this.maxCountryCodeLength) {
          this.country_code = $.trim(countryCode.toString().slice(0, this.maxCountryCodeLength));
        }
        if (this.country_code.toString().length > 0 && this.country_code.toString().length <= this.maxCountryCodeLength ){
          this.errors["mobile_number"] = '';
          if( this.country_code == 91 ) {
              this.maxMobileLength = 10;
              if( this.mobile_number.toString().length > 0 ) {
                if( !this.validateMobileNumber(this.mobile_number) ) // Check is valid entered mobile number
                  this.errors["mobile_number"] = "Please enter valid Mobile Number.";
              }
          }
          else{
            this.maxMobileLength = 13;
            // console.log(" international "+this.validateInternationalMobileNumber(this.mobile_number));
            if( this.mobile_number.toString().length > 0 ) {
              if( !this.validateInternationalMobileNumber(this.mobile_number) )
                this.errors["mobile_number"] = "Please enter valid Mobile Number.";
            }
          }
        }
        else
          this.errors["mobile_number"] = "Please enter valid Country Code";
      },
      mobile_number(mobileNumber){
        this.mobile_number = $.trim(mobileNumber);
        if( mobileNumber.toString().length > this.maxMobileLength ){
          this.mobile_number = $.trim(mobileNumber.toString().slice(0, this.maxMobileLength));
        }
        if( this.mobile_number.toString().length > 0 && this.country_code.toString().length > 0 ) {
          if( this.country_code == 91 ) {
            this.errors["mobile_number"] = '';
            if( !this.validateMobileNumber(this.mobile_number) ) // Check is valid entered mobile number
              this.errors["mobile_number"] = "Please enter valid Mobile Number.";
          }
          else {
            // console.log(" international "+this.validateInternationalMobileNumber(this.mobile_number));
            this.errors['mobile_number'] = '';
            if( !this.validateInternationalMobileNumber(this.mobile_number) ) // Check is valid entered mobile number
              this.errors["mobile_number"] = "Please enter valid Mobile Number.";
          }
        }
      },
      nopepole(entered_nopepole) {
        this.nopepole = entered_nopepole;
        this.errors["nopepole"] = '';
        if( this.nopepole == '' ) 
          this.errors["nopepole"] = "Please enter valid no of pepole.";
      },
      date(entered_date) {
        this.date = entered_date;
        this.errors["date"] = '';
        if( this.date == '' ) 
          this.errors["date"] = "Please enter valid date.";
      },
      time(entered_time) {
        this.time = entered_time;
        this.errors["time"] = '';
        if( this.time == '' ) 
          this.errors["time"] = "Please enter valid time.";
      },
      isChecked(checked) {
      	this.isChecked = checked;
      	// console.log(this.isChecked);
      	if(this.isChecked == true){
      		this.isFormSubmitting = false;
      	}else{
      		this.isFormSubmitting = true;
      	}
      }
    },
    methods: {
    	resetCaptchaModal() {
	      this.$refs.recaptchaModal.reset();
	      this.recaptchaToken = "";
	    },
	    recaptchaVerifiedModal(token) {
	      if (token ){
				this.recaptchaToken = token;
				this.validatePartnerDataForm();
			  } 
	    },
      pepoleLimit: function(){
        var element = event.target;
        var maxlength = element.getAttribute('maxlength');
        if(this.nopepole.toString().length > maxlength){
          let number = this.nopepole;
          this.nopepole = number.toString().substring(0, number.toString().length - 1);
        }
      },
	  async modalClose(){
		this.isPartner = false;
	  },
      async isMobileNumber(evt){
        evt = (evt) ? evt : window.event;
        var charCode = (evt.which) ? evt.which : evt.keyCode;
        if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
          evt.preventDefault();;
        } else {
          return true;
        }
      },
	  validateDate() {
		if (this.date < this.today || this.date > this.maxDate ) {
			// this.errors["date"] = "Date must not be past date";
			this.date = "";
		} else {
			this.errors["date"] = "";
		}
	  },
	  executeCaptcha(){
		//execute captcha call here
        //=========================================
        this.$refs.recaptchaModal.execute();
	  },
      async validatePartnerDataForm(){
        var fullName = $.trim(this.fullname);
        var emailAddress = $.trim(this.email_address);
        var countryCode = $.trim(this.country_code);
        var mobileNumber = $.trim(this.mobile_number);
        var nopepole = $.trim(this.nopepole);
        var date = $.trim(this.date);
        var time = $.trim(this.time);
        console.log("date= "+date);
        console.log("time= "+time);

        // // LET'S VALIDATE FINAL FORM
        if(this.validateCharacters(fullName) && this.validateEmail(emailAddress) && countryCode.toString().length > 0 && ((countryCode == '91' && this.validateMobileNumber(mobileNumber)) || (countryCode !== '91' && this.validateInternationalMobileNumber(mobileNumber))) && this.validateCharacters(fullName) && nopepole != '' && date != '' && time != ''){
    		this.isFormSubmitting = true;
        
			// API data
			let userdata = {
				recaptcha_token: this.recaptchaToken,
				fullname: fullName,
				email: emailAddress,
				country_code: countryCode,
				mobile_number: mobileNumber,
				location:location,
				nopepole:nopepole,
				date:date,
				time:time,
			}
			console.log("=====================");
			console.log(userdata);
			axios.post('/sendTourNotification', userdata).then((apiResponse) => {
				this.isFormSubmitting = false;
                var responseData = apiResponse.data;
				console.log(responseData);
				if( responseData.status == 1 ){
					this.isPartner = true;
					this.showPartnerErrorText = '';
					this.showPartnerError = false;
					this.$refs.recaptchaModal.reset();
				}else{
					this.isPartner = false;
					this.showPartnerError = true;
					this.showPartnerErrorText = responseData.res;
					this.$refs.recaptchaModal.reset();
				}
			}).catch(response => {
				console.log(response.data);
				this.$refs.recaptchaModal.reset();
				this.isFormSubmitting = false;
			});
        }
        else {
			this.isFormSubmitting = false;
			this.$refs.recaptchaModal.reset();
          if (!this.validateCharacters(fullName))
            this.errors["fullname"] = "Please enter valid Name.";
          
          if (!this.validateEmail(emailAddress))
            this.errors["email_address"] = "Please enter valid Email Address.";

          if(nopepole == '')
            this.errors["nopepole"] = "Please enter valid no of pepole.";

          if(date == '')
            this.errors["date"] = "Please enter valid date.";

          if(time == '')
            this.errors["time"] = "Please enter valid time.";
          
          if( (countryCode == '91' && !this.validateMobileNumber(mobileNumber)) ||
            (countryCode !== '91' && !this.validateInternationalMobileNumber(mobileNumber)) )
            this.errors["mobile_number"] = "Please enter valid Mobile Number.";
        }  // endif form validation
      },
      onModalHidden(){
		this.isPartner = false;
        this.fullname = "";
        this.email_address = "";
        this.mobile_number = "";
        this.country_code = "91";
        this.nopepole = "";
		this.showPartnerErrorText = "";
		this.errors=[];
      },
      onModalShown(){
		this.isPartner = false;
        this.errors=[];
		this.showPartnerErrorText = "";
      },
    },
    mounted() {
      $(this.$refs.sceduleTourModal).on("hidden.bs.modal", this.onModalHidden);
      $(this.$refs.sceduleTourModal).on("shown.bs.modal", this.onModalShown);
    }
  };
  </script>
  
  
